<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>微信凭证日志</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" style="margin-top: 20px">
      <el-form-item label="类型:">
        <el-input size="small" v-model="searchType" placeholder="不填查全部" style="width: 260px" clearable @clear="onSearch" />
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="listData" v-loading="loading" border stripe size="small" style="width: 100%">
      <el-table-column type="index" label="#" width="60" align="center" />
      <el-table-column prop="id" label="ID" width="100" align="center" />
      <el-table-column prop="type" label="类型" width="180" align="center" show-overflow-tooltip />
      <el-table-column prop="gw_token" label="gw_token" min-width="280" align="center" show-overflow-tooltip />
      <el-table-column prop="openid" label="openid" min-width="300" align="center" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" width="200" align="center" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="showOpenidDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 20px; text-align: right">
      <el-pagination background layout="total, prev, pager, next"
        :total="total" :page-size="pageSize" :current-page="currentPage"
        @current-change="onPageChange" />
    </div>

    <el-dialog title="openid 详情" :visible.sync="openidVisible" width="500px" :close-on-click-modal="false">
      <div style="white-space: normal; word-break: break-all; line-height: 2; font-size: 14px; max-height: 400px; overflow-y: auto;">{{ openidText }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { wxtokenPage } from '../../api/wxtokenMG'

export default {
  data() {
    return {
      searchType: '',
      listData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      openidVisible: false,
      openidText: ''
    }
  },
  created() { this.loadData() },
  methods: {
    onSearch() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      var params = { pageNo: this.currentPage, pageSize: this.pageSize }
      if (this.searchType) params.type = this.searchType
      wxtokenPage(params).then(res => {
        this.loading = false
        if (res.success !== false) {
          var records = res.data.records || []
          var pad = function (n) { return String(n).padStart(2, '0') }
          records.forEach(function (r) {
            if (r.createTime) {
              var d = new Date(r.createTime)
              if (!isNaN(d.getTime())) {
                r.createTime = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
                  ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
              }
            }
          })
          this.listData = records
          this.total = res.data.total || 0
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('加载失败')
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadData()
    },

    showOpenidDetail(row) {
      this.openidText = row.openid || '--'
      this.openidVisible = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/wxtoken/index.vue